import React from 'react';
import CourseHighlights from '../../Shared/Courses/CourseHighlights';
import ArVrMr2 from '../../../img/Course-Elements/ArVrMr2.png'
import CourseOperate from '../../Shared/Courses/CourseOperate';

const ArVr = () => {


    return (
        <div className='px-4 md:px-12 pt-10'>
            <h4 className='text-blue-500 text-xl'>Certified Online Course</h4>
            <h1 className='text-blue-500 text-5xl font-semibold my-4'>AR, VR <span className='text-orange-400'>and</span> MR</h1>
            <h1 className='text-4xl font-semibold my-4'>Course @ Rs. 1999</h1>
            <h2 className=''>Take the first step in creating your immersive environment by learning to create cutting-edge AR/VR technologies in Unity with the aid of C#!</h2>
            <h3 className='text-xl my-4 font-semibold'>8 Weeks, 45 min /day (3 Recorded+2 Live)</h3>
            <h5>Offer: Get flat Rs.200 off by applying the promo code CAREERHikers</h5>
            <h1 className='text-5xl mt-4 font-bold'>Download the</h1>
            <h1 className='text-5xl mt-2 text-orange-500 font-bold'><span className='text-blue-500'>APP</span> Now!</h1>
            <CourseHighlights />
            <div className='flex mb-8 mt-12'>
                <div className='flex-1 md:mr-4'>
                    <h1 className='text-3xl font-semibold mb-6'>Why Learn Graphic Designing?</h1>
                    <h1 className='text-2xl my-2'>Versatility</h1>
                    <p>The list includes tourism, e-commerce, gaming, education, and entertainment. The work patterns in all industries are on the verge of change thanks to AR and VR technology.</p>
                    <h1 className='text-2xl my-2'>Have high demand</h1>
                    <h3>All of the top IT firms, including Microsoft, Apple, Google, Intel, and others, are searching for AR/VR developers. It seems sense that their average pay, as reported by Glassdoor, is 6 LPA.
                    </h3>
                    <h1 className='text-2xl my-2'>Reconstruct the future</h1>
                    <p>You can alter the course of technology in the future by designing the next Pokemon Go, adding a 3D camera to smartphones, or building smart glasses that will redefine seeing through a combination of AR/VR capabilities.</p>
                </div>
                <img className='flex-1' src={ArVrMr2} alt="" />
            </div>
            <CourseOperate />
        </div>
    );
};
export default ArVr;